export enum License {
  COM = 0x00000000,
  IT = 0x00000008,
  FR = 0x00000010,
  EE = 0x00000020,
  BE = 0x00000040,
  ES = 0x00000080,
  DK = 0x00000100,
  EU = 0x00000200,
  USNJ = 0x00000800,
  UK = 0x00001000,
  BG = 0x00002000,
  DESH = 0x00004000,
  RO = 0x00010000,
  PT = 0x00020000,
  CZ = 0x00040000,
  IN = 0x00080000,
  ASIA = 0x00100000,
  RU = 0x00200000,
  USPA = 0x00400000,
  SE = 0x00800000,
  CH = 0x01000000,
  USMI = 0x01000004,
  NL = 0x01000005,
  CAON = 0x01000006,
  GR = 0x01000022,
  USCO = 0x1000002,
  DE = 0x1000003
}
